import { render } from "./PagosCuentaBancaria.vue?vue&type=template&id=08057272&scoped=true"
import script from "./PagosCuentaBancaria.vue?vue&type=script&lang=js"
export * from "./PagosCuentaBancaria.vue?vue&type=script&lang=js"

import "./PagosCuentaBancaria.vue?vue&type=style&index=0&id=08057272&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08057272"]])

export default __exports__